
import { render } from '@wordpress/element';
import SliderBanner from './components/slider-banner';
window.addEventListener('DOMContentLoaded', (event) => {
    const wrappers = document.getElementsByClassName(`home-slider-one-pure-items`);
    for(let wrapper of wrappers) {
        const slideritems = wrapper.getAttribute('data-items');
        const slideritemsJsonParse = JSON.parse(slideritems)
        render(
            <SliderBanner
                slideritems={slideritemsJsonParse}
            />,
            wrapper
        );
    }
});